import React, { ReactElement } from 'react'
import { clsx } from 'clsx'
import { makeStyles } from '@material-ui/core/styles'

import Icon from '@objects/icon'
import { useAutobahnplakateTexts } from '../store'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: theme.spacing(10),
    transition: 'opacity 0.3s ease-in-out',
    opacity: 0,
    justifyContent: 'center',
    marginBottom: theme.spacing(10),

    [theme.breakpoints.up('md')]: {
      position: 'absolute' as const,
      left: '50%',
      top: theme.spacing(8),
      transform: 'translateX(-50%)',
    },
  },
  visible: {
    opacity: 1,
  },
  iconWrapper: {
    aspectRatio: '1 / 1',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: theme.palette.background.default,
    overflow: 'hidden',
  },
  inner: {
    transition: 'transform 0.3s ease-in-out',
  },

  inner2: {
    transition: 'transform 0.3s ease-in-out 0.1s',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    height: theme.spacing(10),
  },
  labelWrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: theme.spacing(5),
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(0, 6),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  iconVote: {
    fontSize: '21px',
    transform: 'translateX(-1px)',
  },
  iconPencil: {
    fontSize: '17px',
  },
}))

export type IconLabelProps = {
  activeIndex: number
  className?: string
}

export default function IconLabel({
  activeIndex,
  className,
}: IconLabelProps): ReactElement {
  const classes = useStyles()
  const store = useAutobahnplakateTexts()

  const firstStepIndex = store.introOverline ? 1 : 0
  const transform = {
    transform: `translateY(${(activeIndex - firstStepIndex) * 100 * -1}%)`,
  }
  const showStepIndicator =
    !store.hasVotedEffective &&
    activeIndex >= firstStepIndex &&
    activeIndex < store.resultSlideIndex

  return (
    <div
      className={clsx(classes.root, className, {
        [classes.visible]: showStepIndicator,
      })}
    >
      <div className={classes.iconWrapper}>
        <div className={classes.inner} style={transform}>
          <div className={classes.item}>
            <Icon name="Vote" className={classes.iconVote} />
          </div>
          <div className={classes.item}>
            <Icon name="Pencil" className={classes.iconPencil} />
          </div>
        </div>
      </div>
      <div className={classes.labelWrapper}>
        <div className={classes.inner2} style={transform}>
          <h4 className={classes.item}>{store.votingTopline}</h4>
          <h4 className={classes.item}>{store.messageTopline}</h4>
        </div>
      </div>
    </div>
  )
}
